import { SeasonType } from "./enums";

export interface LakeConfig {
    key: string;
    name: string;
    unlockLifetimeScore: number;
    gasDrainMultiplier: number;
    baseWaterColor: number;
    fishWeightMultipliers: Record<string, number>;
}

export interface GameplayLaunchData {
    lakeKey: string;
    season: SeasonType;
}

export const lakeData: LakeConfig[] = [
    {
        key: "lake-mendota",
        name: "Lake Mendota",
        unlockLifetimeScore: 0,
        gasDrainMultiplier: 1,
        baseWaterColor: 0x0f557f,
        fishWeightMultipliers: {
            Bluegill: 1.2,
            Crappie: 1.2,
            Perch: 1.1,
            "Largemouth Bass": 1,
            "Smallmouth Bass": 1,
            Walleye: 0.9,
            Trout: 1,
            "Northern Pike": 0.85,
            Musky: 0.7,
        },
    },
    {
        key: "nagawicka-lake",
        name: "Nagawicka Lake",
        unlockLifetimeScore: 1000,
        gasDrainMultiplier: 1,
        baseWaterColor: 0x175070,
        fishWeightMultipliers: {
            Bluegill: 0.8,
            Crappie: 0.8,
            Perch: 0.9,
            "Largemouth Bass": 1,
            "Smallmouth Bass": 1.1,
            Walleye: 1.35,
            Trout: 1,
            "Northern Pike": 1.35,
            Musky: 0.9,
        },
    },
    {
        key: "musky-bay",
        name: "Musky Bay",
        unlockLifetimeScore: 5000,
        gasDrainMultiplier: 1.25,
        baseWaterColor: 0x15314b,
        fishWeightMultipliers: {
            Bluegill: 0.6,
            Crappie: 0.6,
            Perch: 0.8,
            "Largemouth Bass": 0.9,
            "Smallmouth Bass": 1,
            Walleye: 1.1,
            Trout: 1,
            "Northern Pike": 1.2,
            Musky: 2.2,
        },
    },
];

export const selectableSeasons: SeasonType[] = [SeasonType.Spring, SeasonType.Summer, SeasonType.Fall, SeasonType.Winter];

export function getLakeByKey(lakeKey: string): LakeConfig {
    return lakeData.find((lake) => lake.key === lakeKey) ?? lakeData[0];
}
